import produce from 'immer';
import { LoadingEnv } from '@/webapi/use-widget-catalog-api';
import { QBItemProp } from '@/components/query-builder/models';

export function enrichRecsStrategy(
  cleaned: LoadingEnv,
  props: QBItemProp[],
  ruleProps?: QBItemProp[],
): LoadingEnv {
  if (!cleaned?.recommendationOptions?.layeredRuling) {
    return cleaned;
  }

  return produce(cleaned, (draft) => {
    draft?.recommendationOptions?.layeredRuling?.forEach?.((rule) => {
      rule?.ruleCond?.items?.forEach?.((item) => {
        item.qbProps = ruleProps.find((q) => q.envKey === item.qbProps.envKey);
      });

      rule?.strategyCond?.forEach?.((cond) => {
        cond.qbProps = props.find((q) => q.envKey === cond.qbProps.envKey);
      });
    });
  });
}
